import api from "../apiSetup/apiCall";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const putPopupEdit = createAsyncThunk("popup/putPopupEdit", async (payload) => {
  try {
      const response = await api.put("popup/edit/", payload);
      return response.data;
  } catch (error) {
      console.error("Error put popup/edit/:", error);
      return error.response.data;
  }
});

const PopupEditSlice = createSlice({
    name: "popupEdit",
    initialState: { data: null, error: null, isLoading: false},
    reducers: {},
    extraReducers: (builder) => { builder
        .addCase(putPopupEdit.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        })
        .addCase(putPopupEdit.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        })
        .addCase(putPopupEdit.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload.message;
        });
    },
});

export default PopupEditSlice.reducer;
